module.exports = __webpack_public_path__ + "media/app/assets/races/blood_elf_female-e3ca793e030d47df7914eee2aefd93c3.png";